import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { setPokemonTab } from "../app/slices/AppSlice";
import { pokemonTabs } from "../utils/constants";

const routes = [
  { name: pokemonTabs.description, value: "Description" },
  { name: pokemonTabs.evolution, value: "Evolution" },
  { name: pokemonTabs.locations, value: "Catching" },
  { name: pokemonTabs.moves, value: "Capable Moves" },
];

export default function Footer() {
  const location = useLocation();
  const currentPokemonTab = useAppSelector(
    ({ app: { currentPokemonTab } }) => currentPokemonTab
  );
  const dispatch = useAppDispatch();

  if (!location.pathname.includes("/pokemon")) return null;

  return (
    <footer>
      <div className="block"></div>
      <div className="data">
        <ul>
          {routes.map((route) => (
            <li
              key={route.name}
              className={currentPokemonTab === route.name ? "active" : ""}
              onClick={() => dispatch(setPokemonTab(route.name))}
            >
              {route.value}
            </li>
          ))}
        </ul>
      </div>
      <div className="block"></div>
    </footer>
  );
}
